import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-9 d-flex justify-content-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-5 d-flex justify-content-center"
}
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_6 = { key: 1 }

import { ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeMtGroupForm',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit }) {

const isLoading = ref(false);
const modalForm = ref<InstanceType<typeof SimpleForm>>();
const accountDetail = ref(<any>[]);
const options = ref<any[]>([]);
const label = ref("");
const vModel = ref(<any>null);
const customGroup = ref("");

const updatePlatformGroup = async () => {
  if (!vModel.value && vModel.value !== 0) {
    MsgPrompt.error("Please select a group");
    return;
  }

  // Determine trade account id (try several fallbacks)
  const tradeAccountId =
    accountDetail.value?.tradeAccount?.id ||
    accountDetail.value?.tradeAccount?.uid ||
    accountDetail.value?.id ||
    accountDetail.value?.accountNumber;

  if (!tradeAccountId) {
    MsgPrompt.error("Cannot determine trade account id");
    return;
  }

  // options may store { label: groupName, value: index }
  // If user selected custom, use customGroup value
  let selectedGroup: any = vModel.value;
  if (vModel.value === "__custom__") {
    if (!customGroup.value || !customGroup.value.toString().trim()) {
      MsgPrompt.error("Please enter a custom group name");
      return;
    }
    selectedGroup = customGroup.value.toString().trim();
  } else if (Array.isArray(options.value) && typeof vModel.value === "number") {
    const found = options.value.find((o) => o.value === vModel.value);
    if (found) selectedGroup = found.label;
  }

  // Call tenant API: PUT /api/v1/tenant/trade-account/:accountId/mtgroup
  await AccountService.updateTradeAccountMtGroup(tradeAccountId, {
    group: selectedGroup,
  });

  MsgPrompt.success("Update MT Group successfully").then(() => {
    modalForm.value?.hide();
  });
};

const updateData = async () => {
  isLoading.value = true;
  try {
    await updatePlatformGroup();
    emit("refresh");
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const show = (_accountDetail: any, _data: any) => {
  modalForm.value?.show();
  accountDetail.value = _accountDetail;
  options.value = _data?.options ?? [];
  label.value = _data?.label || "Change MT Group";
  vModel.value =
    _data?.vModel ??
    _accountDetail?.tradeAccount?.tradeAccountStatus?.group ??
    _accountDetail?.group ??
    null;
  customGroup.value = "";
};



__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleForm, {
      ref_key: "modalForm",
      ref: modalForm,
      title: label.value,
      "is-loading": isLoading.value,
      "disable-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_select, {
            modelValue: vModel.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vModel).value = $event)),
            class: "m-2 w-250px",
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item?.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128)),
              _createVNode(_component_el_option, {
                label: _ctx.$t('tip.manualInput'),
                value: '__custom__'
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        (vModel.value === '__custom__')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_input, {
                modelValue: customGroup.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customGroup).value = $event)),
                class: "m-2 w-250px",
                disabled: isLoading.value,
                placeholder: _ctx.$t('tip.pleaseInput')
              }, null, 8, ["modelValue", "disabled", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-light btn-success btn-md me-3",
            onClick: updateData
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                  _hoisted_5
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("action.update")), 1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading"])
  ]))
}
}

})